import React, { useEffect, useState } from "react";
import "./LeaveBalancePanel.css";

export default function LeaveBalancePanel() {
  const [departments, setDepartments] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedDept, setSelectedDept] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [balanceInfo, setBalanceInfo] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Fetch All Employees
  useEffect(() => {
    fetch("https://hrms.urbango.co.in/server/index.php?endpoint=get_all_leave_balances")
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setEmployees(data);
          setFilteredEmployees(data);
          const depts = [...new Set(data.map(e => e.department).filter(Boolean))];
          setDepartments(depts);
        }
      })
      .catch(() => alert("Error loading employee data"));
  }, []);

  // ✅ Department Filter
  useEffect(() => {
    let filtered = [...employees];
    if (selectedDept) filtered = filtered.filter(e => e.department === selectedDept);
    setFilteredEmployees(filtered);
  }, [selectedDept, employees]);

  // ✅ Fetch Single Employee
  useEffect(() => {
    if (!selectedEmployee || selectedEmployee === "all") {
      setBalanceInfo(null);
      return;
    }
    setLoading(true);
    fetch(
      `https://hrms.urbango.co.in/server/index.php?endpoint=get_leave_balance&employeeNo=${encodeURIComponent(selectedEmployee)}`
    )
      .then(res => res.json())
      .then(data => {
        setBalanceInfo(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [selectedEmployee]);

  // ✅ Save Update
  const handleSave = (emp) => {
    fetch("https://hrms.urbango.co.in/server/index.php?endpoint=edit_leave_balance", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(emp),
    })
      .then(res => res.json())
      .then(r => {
        if (r.success) {
          alert("Leave balance updated successfully!");
          setEditingIndex(null);
        } else {
          alert("Failed to update leave balance");
        }
      });
  };

  // ✅ Handle Change
  const handleFieldChange = (index, field, value) => {
    const updated = [...filteredEmployees];
    updated[index][field] = value;
    setFilteredEmployees(updated);
  };

  return (
    <div className="leavebalance-container">
      <h2 className="leavebalance-title">All Employee Leave Balances</h2>

      {/* Filters */}
      <div className="leavebalance-filter-row">
        <div className="leavebalance-filter">
          <label>
            Department:
            <select value={selectedDept} onChange={(e) => setSelectedDept(e.target.value)}>
              <option value="">--All Departments--</option>
              {departments.map(d => (
                <option key={d} value={d}>{d}</option>
              ))}
            </select>
          </label>
        </div>

        <div className="leavebalance-filter">
          <label>
            Employee:
            <select value={selectedEmployee} onChange={(e) => setSelectedEmployee(e.target.value)}>
              <option value="">--Select Employee--</option>
              <option value="all">All Employees</option>
              {filteredEmployees.map(emp => (
                <option key={emp.employeeNo} value={emp.employeeNo}>
                  {emp.fullname}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      {/* Table */}
      {!loading && selectedEmployee === "all" && (
        <div className="leavebalance-table-container">
          <table className="leavebalance-table">
            <thead>
              <tr>
                <th>Emp No</th>
                <th>Name</th>
                <th>Dept</th>
                <th>Type</th>
                <th>Avails</th>
                <th>Carry Fwd</th>
                <th>Total Bal</th>
                <th>Credit</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredEmployees.map((emp, index) => (
                <tr key={emp.employeeNo}>
                  <td>{emp.employeeNo}</td>
                  <td>{emp.fullname}</td>
                  <td>{emp.department}</td>
                  <td>{emp.employeeType}</td>

                  {["leave_avails", "carry_forward", "total_leave_balance", "leave_credit"].map(field => (
                    <td key={field}>
                      {editingIndex === index ? (
                        <input
                          type="number"
                          value={emp[field]}
                          onChange={(e) => handleFieldChange(index, field, e.target.value)}
                        />
                      ) : (
                        emp[field]
                      )}
                    </td>
                  ))}

                  <td>
                    {editingIndex === index ? (
                      <button className="save-btn" onClick={() => handleSave(emp)}>Save</button>
                    ) : (
                      <button className="edit-btn" onClick={() => setEditingIndex(index)}>Edit</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Single Employee Card */}
      {balanceInfo && selectedEmployee !== "all" && (
        <div className="leavebalance-card">
          <h3>{balanceInfo.fullname}</h3>
          <p><b>Department:</b> {balanceInfo.department}</p>
          <p><b>Type:</b> {balanceInfo.employeeType}</p>
          <p><b>Avails:</b> {balanceInfo.leave_avails}</p>
          <p><b>Carry Forward:</b> {balanceInfo.carry_forward}</p>
          <p><b>Total Balance:</b> {balanceInfo.total_leave_balance}</p>
          <p><b>Credit:</b> {balanceInfo.leave_credit}</p>
        </div>
      )}
    </div>
  );
}
